
export interface AdhocHoldOfCntrEntity {
    consortiumCode: string|null,
    vesselCode: string|null,
    voyageCode: string|null,
    containerNo: string|null,
    billOfLading: string|null,
    shippingBill: string|null,
    reasonCode: string|null,

    [key: string]: string | null | undefined
}

export const EMPTY_ADHOC_HOLD_OF_CNTR_ENTITY: AdhocHoldOfCntrEntity = {
    consortiumCode: "",
    vesselCode: "",
    voyageCode: "",
    containerNo: "",
    billOfLading: "",
    shippingBill: "",
    reasonCode: ""
}